// extracted by mini-css-extract-plugin
export default {"zoomGroup":"Zoom_zoomGroup__-1ThX"};